(() => {

let initialized = false;

document.addEventListener("DOMContentLoaded", init);

document.addEventListener("shopify:section:load", init);

function init(){

    observeCart();

    runBundleEngine();

    initRemoveSync();

}

function observeCart(){

    if(initialized) return;

    initialized = true;

    const cartTable = document.querySelector(".cart-items__table");

    if(!cartTable){
        return;
    }

    const observer = new MutationObserver(function(mutations){

        // Ignore mutations caused by our bundle UI
        const hasRealCartChange = mutations.some(mutation => {

            return [...mutation.addedNodes].some(node => {

                return node.nodeType === 1 &&
                    !node.classList?.contains("za-bundle-box");

            });

        });

        if(!hasRealCartChange){
            return;
        }

        clearTimeout(window.bundleTimeout);

        window.bundleTimeout = setTimeout(function(){

            runBundleEngine();

        },150);

    });

    observer.observe(cartTable,{

        childList:true,
        subtree:true

    });

}

async function runBundleEngine(){

    const cartTable = document.querySelector(".cart-items__table");

    if(!cartTable){
        return;
    }

    try{

        const response = await fetch("/cart.js");
        const cart = await response.json();

        // Stop if cart is empty
        if(cart.item_count === 0){
            return;
        }

        // Stop if there are no bundle parents
        const hasBundle = cart.items.some(item =>
            item.properties &&
            item.properties._bundle_type === "parent"
        );

        if(!hasBundle){
            return;
        }

        buildBundleMap(cart.items);

    }
    catch(error){

        console.error("Bundle Error", error);

    }

}

function buildBundleMap(items){

    const bundles = {};

    // Create Parent Bundles
    items.forEach(item => {

        const props = item.properties || {};

        if(props._bundle_type === "parent"){

            bundles[props._bundle_id] = {

                parent: item,
                children: []

            };

        }

    });

    // Attach Children
    items.forEach(item => {

        const props = item.properties || {};

        if(props._bundle_type === "child"){

            const id = props._bundle_parent;

            if(bundles[id]){

                bundles[id].children.push(item);

            }

        }

    });

    mapBundleRows(bundles);

}

function mapBundleRows(bundles){
    

    Object.values(bundles).forEach(bundle => {

        if(bundle.children.length === 0){
            return;
        }

        const parentRow = findRow(bundle.parent.key);

if (!parentRow) {
    return;
}

let bundleTotal = bundle.parent.final_price;

bundle.children.forEach(child => {
    bundleTotal += child.final_price;
});

const fallbackPrice = parentRow.querySelector(".cart-items__price");

if (fallbackPrice) {
    fallbackPrice.innerHTML =
        "$" + (bundleTotal / 100).toFixed(2);
}


        if(!parentRow){
            return;
        }

        // Hide child rows
        bundle.children.forEach(child => {

            const childRow = findRow(child.key);

            if(childRow){
                childRow.style.display = "none";
            }

        });

        // Permanent placeholder from Liquid
        const bundleBox = parentRow.querySelector(
            `.za-bundle-box[data-bundle-key="${bundle.parent.key}"]`
        );

        if(!bundleBox){
            return;
        }

        let html = `
            <div class="za-bundle-title">
                Selected Add-ons
            </div>
        `;

        bundle.children.forEach(child => {

            html += `
                <div class="za-addon-row">

                    <span class="za-addon-check">✔</span>

                    <span class="za-addon-name">
                        ${child.product_title}
                    </span>

                    <span class="za-addon-price">
                        $${(child.final_price / 100).toFixed(2)}
                    </span>

                </div>
            `;

        });



        bundleBox.innerHTML = html;
        bundleBox.style.display = "block";
        bundleBox.dataset.rendered = "true";



    });

}

function findRow(key) {

    const rows = document.querySelectorAll(".cart-items__table-row");

    for (const row of rows) {

        if (row.dataset.key === key) {
            return row;
        }

    }

    return null;

}

async function removeBundle(bundleId){

    const response = await fetch("/cart.js");
    const cart = await response.json();

    const updates = {};

    cart.items.forEach((item, index) => {

        const props = item.properties || {};

        if(
            props._bundle_id === bundleId ||
            props._bundle_parent === bundleId
        ){
            updates[index + 1] = 0;
        }

    });

    await fetch("/cart/update.js",{

        method:"POST",

        headers:{
            "Content-Type":"application/json"
        },

        body:JSON.stringify({
            updates
        })

    });

    window.location.reload();

}

function initRemoveSync(){

    document.addEventListener("click",async function(e){

        const removeButton = e.target.closest(
            '[onclick*="onLineItemRemove"],button[name="remove"]'
        );

        if(!removeButton){
            return;
        }

        const row = removeButton.closest(".cart-items__table-row");

        if(!row){
            return;
        }

        const bundleId = row.dataset.bundleId;

        if(!bundleId){
            return;
        }

        e.preventDefault();
        e.stopImmediatePropagation();

        await removeBundle(bundleId);

    },true);

}


})();